import { Button, Checkbox, Col, Form, Modal, Row, Spin, Input } from 'antd';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import BreadCrumbs from '../../../../common/components/Breadcrumbs';
import { validateMessages } from '../../../../common/constants/common';
import { Page } from '../../../../common/constants/pageAction';
import { getObjectForUpdateMultiple } from '../../../../common/helperFunction';
import { IConfigSoftwarePublisher } from '../../../../services/master/configSoftwarePublisher/configSoftwarePublisher.model';
import { useAppSelector, useAppDispatch } from '../../../../store/app.hooks';
import { updateMultiple } from '../../../../store/common/common.action';
import {
  clearMultipleUpdateMessages,
  commonSelector,
} from '../../../../store/common/common.reducer';
import {
  getConfigSoftwarePublisherById,
  saveConfigSoftwarePublisher,
} from '../../../../store/master/configSoftwarePublisher/configSoftwarePublisher.action';
import {
  clearConfigSoftwarePublisherGetById,
  clearConfigSoftwarePublisherMessages,
  configSoftwarePublisherSelector,
} from '../../../../store/master/configSoftwarePublisher/configSoftwarePublisher.reducer';
import { IAddConfigSoftwarePublisherProps } from './addConfigSoftwarePublisher.model';

const AddConfigSoftwarePublisherModal: React.FC<IAddConfigSoftwarePublisherProps> = (props) => {
  const configSoftwarePublisher = useAppSelector(configSoftwarePublisherSelector);
  const common = useAppSelector(commonSelector);
  const dispatch = useAppDispatch();
  const { id, showModal, handleModalClose, refreshDataTable, isMultiple, valuesForSelection } =
    props;

  const isNew: boolean = id || isMultiple ? false : true;
  const title = useMemo(() => {
    return (
      <>
        {isNew ? 'Add ' : 'Edit '} <BreadCrumbs pageName={Page.ConfigSoftwarePublisher} level={1} />
      </>
    );
  }, [isNew]);
  const submitButtonText = useMemo(() => {
    return isNew ? 'Save' : 'Update';
  }, [isNew]);

  const [form] = Form.useForm();

  let initialValues: IConfigSoftwarePublisher = {
    publisher: '',
  };

  const onFinish = (values: any) => {
    const inputValues: IConfigSoftwarePublisher = {
      ...values,
      id: id ? +id : null,
    };
    if (!isMultiple) {
      dispatch(saveConfigSoftwarePublisher(inputValues));
    } else {
      const result = getObjectForUpdateMultiple(
        valuesForSelection,
        inputValues,
        configSoftwarePublisher.search.tableName
      );
      if (result) {
        dispatch(updateMultiple(result));
      }
    }
  };

  const fillValuesOnEdit = async (data: IConfigSoftwarePublisher) => {
    if (data) {
      initialValues = {
        publisher: data.publisher,
      };
      form.setFieldsValue(initialValues);
    }
  };

  useEffect(() => {
    if (configSoftwarePublisher.save.messages.length > 0) {
      if (configSoftwarePublisher.save.hasErrors) {
        toast.error(configSoftwarePublisher.save.messages.join(' '));
      } else {
        toast.success(configSoftwarePublisher.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearConfigSoftwarePublisherMessages());
    }
  }, [configSoftwarePublisher.save.messages]);

  useEffect(() => {
    if (common.save.messages.length > 0) {
      if (common.save.hasErrors) {
        toast.error(common.save.messages.join(' '));
      } else {
        toast.warn(common.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearMultipleUpdateMessages());
    }
  }, [common.save.messages]);

  useEffect(() => {
    if (+id > 0 && configSoftwarePublisher.getById.data) {
      const data = configSoftwarePublisher.getById.data;
      fillValuesOnEdit(data);
    }
  }, [configSoftwarePublisher.getById.data]);

  useEffect(() => {
    if (+id > 0) {
      dispatch(getConfigSoftwarePublisherById(+id));
    }
    return () => {
      dispatch(clearConfigSoftwarePublisherGetById());
    };
  }, [dispatch]);

  return (
    <>
      <Modal
        wrapClassName="custom-modal"
        title={title}
        centered
        visible={showModal}
        onCancel={handleModalClose}
        footer={false}
      >
        {configSoftwarePublisher.getById.loading ? (
          <div className="spin-loader">
            <Spin spinning={configSoftwarePublisher.getById.loading} />
          </div>
        ) : (
          <Form
            form={form}
            name="configSoftwarePublisher"
            initialValues={initialValues}
            onFinish={onFinish}
            validateMessages={validateMessages}
          >
            <Row gutter={[30, 15]} className="form-label-hide">
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'publisher']} valuePropName="checked" noStyle>
                      <Checkbox>Publisher</Checkbox>
                    </Form.Item>
                  ) : (
                    'Publisher'
                  )}
                  <Form.Item
                    name="publisher"
                    label="Publisher"
                    className="m-0"
                    rules={[{ required: !isMultiple, max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <div className="btns-block modal-footer">
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={configSoftwarePublisher.save.loading || common.save.loading}
              >
                {submitButtonText}
              </Button>
              <Button key="back" onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </>
  );
};
export default AddConfigSoftwarePublisherModal;
